// "Abiertos ahora" (D37): los casos que la persona abrio, fijos en la columna de la Bandeja como las pestañas de
// Zammad. Se guardan en este navegador, por persona; se quitan con la X o al resolver el caso.
import { useSyncExternalStore } from 'react';

import { readJSON, writeJSON } from './storage';

const MAX = 15;
const clave = (miembroId: string) => `consola.casos.abiertos.${miembroId}`;
let dueno = '';
let ids: string[] = [];
const subs = new Set<() => void>();

function cargar(miembroId: string) {
  if (dueno === miembroId) return;
  dueno = miembroId;
  ids = readJSON<string[]>(clave(miembroId), []).filter((x) => typeof x === 'string').slice(-MAX);
}

function guardar(nuevos: string[]) {
  ids = nuevos;
  if (dueno) writeJSON(clave(dueno), ids);
  subs.forEach((s) => s());
}

export function fijarCaso(miembroId: string | undefined, id: string) {
  if (!miembroId) return;
  cargar(miembroId);
  if (!ids.includes(id)) guardar([...ids, id].slice(-MAX));
}

export function quitarCaso(miembroId: string | undefined, id: string) {
  if (!miembroId) return;
  cargar(miembroId);
  if (ids.includes(id)) guardar(ids.filter((x) => x !== id));
}

export function usePestanas(miembroId: string | undefined) {
  if (miembroId) cargar(miembroId);
  return useSyncExternalStore(
    (cb) => {
      subs.add(cb);
      return () => subs.delete(cb);
    },
    () => (miembroId ? ids : SIN),
  );
}
const SIN: string[] = [];
